<template>
	<div
		class="rating"
		:class="[`-${size}`]"
	>
		<span
			v-for="(star, i) in stars"
			:key="i"
			class="rating__star"
			@mouseover="() => hover = star"
			@mouseout="hover = 0"
			@click.stop="setRating(star)"
		>
			<Icon
				:icon-name="(hover === 0 && value && value >= star) || hover >= star ? 'star-filled' : 'star'"
				:size="size"
			/>
		</span>
	</div>
</template>

<script>
import Icon from '@components/Icon';

const SIZE = {
	sm: 'sm',
	md: 'md',
	lg: 'lg',
};

export default {
	name:       'Rating',
	components: { Icon },
	props:      {
		value: {
			type:    Number,
			default: null,
		},
		size: {
			type:      String,
			default:   'lg',
			validator: (value) => Object.values(SIZE).includes(value),
		},
	},
	data() {
		return {
			stars: [1, 2, 3, 4, 5],
			hover: 0,
		};
	},
	methods: {
		setRating(star) {
			if (star === this.value) {
				this.hover = 0;
			}
			const rating = star === this.value ? null : star;
			this.$emit('change', rating);
		},
	},
};
</script>

<style lang="scss" scoped>
	.rating {
		display: flex;
		align-items: center;

		&.-sm {
			height: 24px;
		}
	}

	.rating__star {
		cursor: pointer;
	}
</style>
